export default "__VITE_ASSET__2SpGxRfw__"